import { List, Button, Tag, Input, Select, Switch } from 'antd'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { comparatorTypes } from '../constants'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import './RelationConfig.scss'

ConditionalRenderingRules = ({ value = ['name'], onChange }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()

  setRule = (i, val) ->
    if _.isObject(val) and _.isObject(value[i])
      value[i] = { value[i]..., val... }
    else
      value[i] = val
    onChange(value)

  <div style={{ paddingBottom: 20 }} className="relation-rules">
    <List
      bordered
      dataSource={value}
      locale={{ emptyText: 'No rules' }}
      renderItem={(item, i) ->
        actions = [
          <Select
            placeholder="Key"
            value={if _.isString(item) then item else item.key}
            onChange={(value) ->
              if _.isString(item)
                setRule(i, value)
              else
                setRule(i, { key: value })
            }
            style={{ width: '100%' }}
          >
            {_.values(fieldData).filter(({ key }) -> key? && key isnt '').map(({ key }) ->
              <Select.Option
                value={key}
                key={key}
              >{ _.startCase(key) }</Select.Option>
            )}
          </Select>,
          <Button
              onClick={ ->
                value.splice(i, 1)
                onChange(value)
              }
              icon={<CloseOutlined />}
              type='link'
              danger
            />
        ]
        if !_.isString(item)
          actions.splice(1, 0,
            <Select
              placeholder="Type"
              value={item.type}
              options={[
                { label: '=', value: comparatorTypes.EQUAL_TO }
                { label: '≠', value: comparatorTypes.NOT_EQUAL_TO }
                { label: '>', value: comparatorTypes.GREATER_THAN }
                { label: '<', value: comparatorTypes.LESS_THAN }
              ]}
              optionLabelProp="label"
              onSelect={(value) -> setRule(i, { type: value })}
            />,
            <Input
              placeholder="Value"
              style={{ display: 'inline' }}
              value={item.value}
              onChange={({ target: { value }}) -> setRule(i, { value })}
            />
          )
        <List.Item actions={actions}>
          <Switch
            checkedChildren="Complex"
            unCheckedChildren="Simple"
            checked={_.isObject(item)}
            onChange={(checked) ->
              if !checked
                if _.isObject(item)
                  val = item.key or 'name'
              else
                if _.isString(item)
                  val = { key: item }
                else
                  val = { key: 'name' }
              setRule(i, val)
            }
          />
        </List.Item>
      }
    />
    <Button
      type="link"
      style={{ float: 'right', margin: '10px 0' }}
      icon={<PlusOutlined />}
      onClick={ -> onChange([value..., 'name'])}
    >Add new rule</Button>
  </div>

export default ConditionalRenderingRules